import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="/images/SuccessPro Digital Logo.png" 
              alt="SuccessPro Digital" 
              className="h-8 w-auto brightness-0 invert"
            />
            <p className="font-body text-sm text-primary-foreground/80">
              20 years of building the web. Now, we're building your business with modern, 
              affordable websites that put you in control.
            </p>
            <div className="flex space-x-4">
              <Button variant="ghost" size="icon" className="text-primary-foreground/80 hover:text-accent">
                <Facebook className="h-4 w-4" />
              </Button>
              <Button variant="ghost" size="icon" className="text-primary-foreground/80 hover:text-accent">
                <Twitter className="h-4 w-4" />
              </Button>
              <Button variant="ghost" size="icon" className="text-primary-foreground/80 hover:text-accent">
                <Linkedin className="h-4 w-4" />
              </Button>
              <Button variant="ghost" size="icon" className="text-primary-foreground/80 hover:text-accent">
                <Instagram className="h-4 w-4" />
              </Button>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-heading font-semibold text-lg">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                Home
              </Link>
              <Link to="/services" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                Services
              </Link>
              <Link to="/about" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                About Us
              </Link>
              <Link to="/case-studies" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                Case Studies
              </Link>
              <Link to="/client-training" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                Client Training
              </Link>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="font-heading font-semibold text-lg">Services</h3>
            <div className="space-y-2">
              <Link to="/web-development" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                Website Development
              </Link>
              <Link to="/social-media" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                Social Media Marketing
              </Link>
              <Link to="/maintenance" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                Maintenance & Support
              </Link>
              <Link to="/client-training" className="block font-body text-sm text-primary-foreground/80 hover:text-accent transition-colors">
                Client Training
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="font-heading font-semibold text-lg">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-accent" />
                <span className="font-body text-sm text-primary-foreground/80">hello@successpro.digital</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-accent" />
                <span className="font-body text-sm text-primary-foreground/80">(555) 123-4567</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="h-4 w-4 text-accent" />
                <span className="font-body text-sm text-primary-foreground/80">Your City, State</span>
              </div>
            </div>
            <Button 
              asChild 
              className="bg-accent hover:bg-accent/90 text-accent-foreground font-heading font-semibold"
            >
              <Link to="/booking">Schedule Consultation</Link>
            </Button>
          </div>
        </div>

        <Separator className="my-8 bg-primary-foreground/20" />

        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="font-body text-sm text-primary-foreground/60">
            © 2024 SuccessPro Digital. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="#" className="font-body text-sm text-primary-foreground/60 hover:text-accent transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="font-body text-sm text-primary-foreground/60 hover:text-accent transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;